/**
 * @mixin
 */
export default {
  data: () => ({}),
  computed: {},
  methods: {},
};
